/**
 * @deprecated Prefer `application-types` for visitor pass query types
 * (VisitorPassQueryResponse, VisitorWatchlistDetails, WatchlistSeverityLevel, etc.).
 * EventStatus / RecurrenceEventStatus remain in `constants-visitor-management`.
 */
import { ActivateVisitor } from './VisitorType';
import { RecurrenceQueryResponse } from './Recurrence';
import { Channel } from '../../../types/ChannelType';

/**
 * @deprecated Use EventStatus from constants-visitor-management (EventStatus.ts).
 */
export enum EventStatus {
  EVENT_STATUS_INVALID = 'EVENT_STATUS_INVALID',
  /** EVENT_STATUS_PENDING - Created but not confirmed */
  EVENT_STATUS_PENDING = 'EVENT_STATUS_PENDING',
  /** EVENT_STATUS_UPCOMING - Pass approved and ready to be scanned */
  EVENT_STATUS_UPCOMING = 'EVENT_STATUS_UPCOMING',
  /** When visitorValidation is true upcoming can only go to validated */
  EVENT_STATUS_VALIDATED = 'EVENT_STATUS_VALIDATED',
  EVENT_STATUS_CHECKED_IN = 'EVENT_STATUS_CHECKED_IN',
  EVENT_STATUS_CHECKED_OUT = 'EVENT_STATUS_CHECKED_OUT',
  /** EVENT_STATUS_NO_SHOW - Pass was not used during time range, or manually marked */
  EVENT_STATUS_NO_SHOW = 'EVENT_STATUS_NO_SHOW',
  EVENT_STATUS_CANCELLED = 'EVENT_STATUS_CANCELLED',
  RECURRENCE_EVENT_STATUS_CANCELLED = 'RECURRENCE_EVENT_STATUS_CANCELLED',
  /** EVENT_STATUS_WITHDRAWN - Pass was checked in but cancelled within the valid timeframe */
  EVENT_STATUS_WITHDRAWN = 'EVENT_STATUS_WITHDRAWN',
  EVENT_STATUS_DELETED = 'EVENT_STATUS_DELETED',
  /** EVENT_STATUS_ARCHIVED - Pass belonged to a recurrence that has been updated */
  EVENT_STATUS_ARCHIVED = 'EVENT_STATUS_ARCHIVED',
  /** EVENT_STATUS_EXPIRED - Pass was checked in but not checked out until end time elapsed */
  EVENT_STATUS_EXPIRED = 'EVENT_STATUS_EXPIRED',
  /** EVENT_STATUS_REJECTED - Pass was rejected */
  EVENT_STATUS_REJECTED = 'EVENT_STATUS_REJECTED',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export interface VisitorPassUserProfileType {
  email: string;
  phone: string;
  image: string;
}

export interface VisitorPassHostType {
  _id: string;
  name: string;
  profile: VisitorPassUserProfileType;
}

export interface VisitorPassQueryResponse {
  id: string;
  visitor: ActivateVisitor;
  sourceId?: string; // Content Id
  submissionId?: string; // UCI Id
  submissionVisitorId?: string;
  recurrenceId?: string;
  createdByUserId: string;
  hostUserId: string;
  hostTenantId: string;
  hostName: string;
  tenantName: string;
  host?: VisitorPassHostType;
  tenant?: Partial<Channel>;
  floor?: string;
  accessGrantBuildingId: string; // Channel / Building Id
  companyName: string;
  status: string;
  visitorNote?: string;
  staffNote?: string;
  eventName: string;
  startDatetime?: string;
  endDatetime?: string;
  createdAtDatetime?: string;
  updatedAtDatetime?: string;
  submittedBy: string;
  updatedBy: string;
  validStateTransitions: string[];
  checkedInDatetime?: string;
  checkedOutDatetime?: string;
  currentVersion: number;
  whiteLabelId: string;
  additionalRecipients?: string[];
  visitorWatchlistMatchInfo?: VisitorWatchlistMatchInfo[];
  watchlistDetails?: VisitorWatchlistDetails;
}

export type VisitorPassesAndRecurrencesQueryResponse = {
  visitorPasses: VisitorPassQueryResponse[];
  recurrences: RecurrenceQueryResponse[];
};

export type VisitorPassChangeDetails = {
  visitorPassId: string;
  changeNote: string;
  startDatetime: Date | undefined;
  endDatetime: Date | undefined;
};

export interface VisitorWatchlistMatchInfo {
  watchlistSeverityLevel: WatchlistSeverityLevel;
  watchlistId?: string;
  isApprovalRequired?: boolean;
  isWatchlistDisplayed?: boolean;
  displayText?: string;
}

export interface VisitorMatchingRule {
  primaryValue: string;
  alternateValues: string[];
  matchType: string;
}

export interface VisitorMatchingInfo {
  firstName?: VisitorMatchingRule;
  lastName?: VisitorMatchingRule;
  email?: VisitorMatchingRule;
  phone?: VisitorMatchingRule;
}

export interface VisitorWatchlist {
  id: string;
  organizationId: string;
  visitorMatchingInfo?: VisitorMatchingInfo;
  severityLevel: string;
  notes?: string;
  attachmentIds?: string[];
  reportedBy?: string;
  createdBy?: string;
  createdByName?: string;
  updatedBy?: string;
  updatedByName?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface VisitorWatchlistMatchDetails {
  visitorWatchlistId: string;
  severityLevel: string;
  displayLevelText: string;
  matchedFields: string[];
  notes?: string;
  visitorWatchlist?: VisitorWatchlist;
}

export interface VisitorWatchlistDetails {
  matches: VisitorWatchlistMatchDetails[];
  pendingSubmissionVisitors?: Array<{
    id: string;
    visitor: ActivateVisitor;
    status: string;
    startDatetime?: string;
    endDatetime?: string;
  }>;
}

export enum WatchlistSeverityLevel {
  WATCHLIST_SEVERITY_LEVEL_INVALID = 'WATCHLIST_SEVERITY_LEVEL_INVALID',
  WATCHLIST_SEVERITY_LEVEL_HIGH = 'WATCHLIST_SEVERITY_LEVEL_HIGH',
  WATCHLIST_SEVERITY_LEVEL_MEDIUM = 'WATCHLIST_SEVERITY_LEVEL_MEDIUM',
  WATCHLIST_SEVERITY_LEVEL_LOW = 'WATCHLIST_SEVERITY_LEVEL_LOW',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
